import { render, staticRenderFns } from "./CatalogueCard.vue?vue&type=template&id=2c9239d8&scoped=true"
import script from "./CatalogueCard.vue?vue&type=script&lang=js"
export * from "./CatalogueCard.vue?vue&type=script&lang=js"
import style0 from "./CatalogueCard.vue?vue&type=style&index=0&id=2c9239d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9239d8",
  null
  
)

export default component.exports